import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f04e2db"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12 member-h" }, "会員区分")
], -1))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12 confirm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "会員プラン設定の確認", -1))
const _hoisted_6 = {
  key: 0,
  class: "show"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "有効期限", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  key: 1,
  class: "show"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "変更が完了しました。", -1))
const _hoisted_15 = [
  _hoisted_14
]

import { Member, PointHistory, PaymentMethod, Shop, MemberType, Group } from '@/models';
import { Auth, DataStore } from 'aws-amplify';
import { inject, onMounted, reactive, ref, toRefs, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { CardListDto, CardPaymentDto } from '../../../../common/card.dto';
import Modal from '../../components/Modal.vue'
import 'dayjs/locale/ja'
import dayjs from 'dayjs';
import { Api } from '@/store/api';

interface Props {
  member: Member;
  shop: Shop;
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null,
    shop: null,
    loading: { type: Boolean }
  },
  emits: ['stopLoading','startLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
  shop: Shop;
  loading: boolean;
}

const ADD_EXPIRE_DATE = 30;

const route = useRoute();
const router = useRouter();



const { member, shop, loading } = toRefs(props);



const api: any = inject('api');

const card = ref<CardListDto>();
const selected = ref<MemberType>();
const current = ref<MemberType>();
const typeLists = ref<(MemberType | null)[]>();

const price = ref(0);

const nextExpire = ref();

const success = ref(false);
const error = ref(false);

const confirm = async(item: MemberType) => {
  if (!item.monthlyPrice) {
    console.log('monthlyPrice is null');
    return;
  }
  if (item.id == current.value?.id) {
    return;
  }
  emit('startLoading');
  selected.value = item;

  nextExpire.value = dayjs().add(ADD_EXPIRE_DATE+1, 'day').format('YYYY-MM-DD');

  // first
  if (!current.value || !member.value.memberExpire) {
    price.value = item.monthlyPrice!;
  }
  // Upgrade
  else if (dayjs(member.value.memberExpire) > dayjs(new Date())) {
    const diff = dayjs(member.value.memberExpire).diff(dayjs(new Date()), 'day');
    const remaining = Math.floor(current.value.monthlyPrice! * diff / ADD_EXPIRE_DATE);
    price.value = item.monthlyPrice! - remaining;
  }
  else {
    price.value = item.monthlyPrice!;
  }

  console.log(price.value);
  emit('stopLoading');
}

const unselect = async() => {
  selected.value = undefined;
  emit('stopLoading');
}


const payment = async() => {
  if (member.value!.point! - price.value < 0) {
    return;
  }
  emit('startLoading');
  try {
    console.log(price.value);
    await api.paymentMonthly(member.value, price.value, selected.value!, nextExpire.value);
    success.value = true;
  }
  catch (e) {
    console.log(e);
    error.value = true;
  }
  emit('stopLoading');
}

watch([member, shop], async() => {
  try {
    console.log('updated ' + member.value.name);
    
    await nextTick();
    
    console.log('updated ' + shop.value.name);

    const group = (await DataStore.query(Group, (g) => g.id('eq', shop.value.groupID!)))[0];

    typeLists.value = await DataStore.query(MemberType, (t) => t.and(
      t => t.groupID('eq', group.id).monthlyPrice('ne', 0)
    ));

    typeLists.value = typeLists.value.filter(x => x?.monthlyPrice != null);
    
    const memberTypeId : any = member.value.memberType?.id;

    current.value = typeLists.value.filter((x: MemberType | null) => x?.id == memberTypeId)[0]!;
  }
  catch(e) {
    console.log(e);
  }

  emit('stopLoading');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeLists.value, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        onClick: ($event: any) => (confirm(item!)),
        class: "row justify-content-center mb-3"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-8 member-type", {'selected' : _unref(member).memberType?.id == item?.id}])
        }, [
          _createElementVNode("div", null, _toDisplayString(item?.name), 1)
        ], 2)
      ], 8, _hoisted_2))
    }), 128)),
    _createVNode(Modal, {
      visible: selected.value != undefined && !_unref(loading),
      onHide: unselect
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (!success.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", null, _toDisplayString(selected.value?.name), 1),
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("p", null, _toDisplayString(_unref(dayjs)(nextExpire.value).format('YYYY年MM月DD日')), 1)
                  ]),
                  _createElementVNode("div", null, [
                    (_unref(member).point! - price.value < 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString((price.value - _unref(member).point!).toLocaleString()) + " pt不足しています。 ", 1))
                      : _createCommentVNode("", true),
                    (_unref(member).point! - price.value >= 0 && price.value >= 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(price.value.toLocaleString()) + " ptのお支払いが発生します。 ", 1))
                      : _createCommentVNode("", true),
                    (_unref(member).point! - price.value >= 0 && price.value < 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString((-price.value).toLocaleString()) + " ptが還元されます。 ", 1))
                      : _createCommentVNode("", true),
                    (_unref(member).point! - price.value >= 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 変更手続きをしますか？ "))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (success.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
            (!success.value && !_unref(loading) && _unref(member).point! - price.value >= 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "btn-modal",
                  onClick: payment
                }, "はい"))
              : _createCommentVNode("", true),
            (!success.value && !_unref(loading))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "btn-modal btn-cancel",
                  onClick: unselect
                }, "キャンセル"))
              : _createCommentVNode("", true),
            (success.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "btn-modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
                }, "ホームへ戻る"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})